export default __webpack_public_path__ + "locales/lv/MainBar.json?hash=57b8e611b069aa69f54f742281c27fe7";